import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const PaginationStyle = styled('div')`
  padding: 18px 0;
  position: relative;
  ${media.mobile} {
    background-color: #f6f6f6;
  }
  ${media.desktop} {
    display: flex;
    justify-content: space-between;
  }
  .pagination {
    &--numbers {
      display: flex;
      justify-content: center;
      width: 170px;
      margin: 0 auto;
    }
    &--number {
      font-family: 'Gilroy-ExtraBold';
      font-size: 18px;
      color: #cfcfcf;
      width: 10px;
      text-align: center;
      ${media.mobile} {
        &:not(:last-of-type) {
          margin-right: 30px;
        }
      }
      ${media.desktop} {
        margin-right: 28px;
      }
      &.active {
        color: #333333;
        border-bottom: 3px solid #333333;
      }
    }
    &--arrow {
      ${media.mobile} {
        position: absolute;
        top: 14px;
      }
      &.left {
        transform: rotate(90deg);
        ${media.mobile} {
          left: 11px;
        }
        ${media.desktop} {
          margin-right: 8px;
          margin-left: 7px;
        }
      }
      &.right {
        transform: rotate(-90deg);
        ${media.mobile} {
          right: 11px;
        }
        ${media.desktop} {
          margin-right: 7px;
          margin-left: 8px;
        }
      }
    }
  }
  .prevbutton {
    &.nonvisible {
      visibility: hidden;
    }
  }
  .arrow-desktop-wrap {
    position: absolute;
    &.right {
      right: 0;
    }
  }
  .arrow-desktop {
    display: flex;
    font-size: 12px;
    color: #555555;
  }
`;

export default PaginationStyle;
